import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

import components from '@/components';
import contentLock from '@/helpers/content-lock';
import filters from '@/components/filters';
import plugins from '@/plugins';
import store from '@/store';
import VueMasonry from 'vue-masonry-css';

filters.init();
plugins.init();
Vue.use(VueMasonry);

window.eventHub = new Vue();

new Vue({ // eslint-disable-line no-new
    el: '#app',
    components,
    store,
    data() {
        return {
            blankImage: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
            showMenu: false,
        };
    },
    computed: {
        ...mapState('modal', [
            'modal',
        ]),
    },
    methods: {
        ...mapMutations('modal', [
            'setModal',
        ]),

        toggleMenu() {
            this.showMenu = !this.showMenu;
            contentLock.toggle();
        },

        boxToggle(target) {
            const element = document.querySelector(target);
            element.classList.toggle('open');
        },
    },
});
